/**
 * UYARI İŞARETLERİ — ekranda görünen her biri bir anormallik demektir:
 * üçgen (uyarı, sarı) ve ünlem dairesi (hata, kırmızı). Renk çağıranın
 * `text-warn` / `text-danger` sınıfından gelir (`currentColor`).
 */

export function UyariIkonu({ tone }: { readonly tone: "warn" | "danger" }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" className="block">
      {tone === "danger" ? (
        <>
          <circle cx="8" cy="8" r="7" fill="currentColor" />
          <rect x="7.1" y="3.6" width="1.8" height="5.6" rx="0.9" fill="var(--pf-surface)" />
          <circle cx="8" cy="11.6" r="1.05" fill="var(--pf-surface)" />
        </>
      ) : (
        <>
          <path d="M8 1.2 15.2 14.3H.8Z" fill="currentColor" strokeLinejoin="round" />
          <rect x="7.15" y="5.4" width="1.7" height="4.9" rx="0.85" fill="var(--pf-surface)" />
          <circle cx="8" cy="12.2" r="0.95" fill="var(--pf-surface)" />
        </>
      )}
    </svg>
  );
}
